import type { FC } from 'react';
import Image from 'next/image';
import { cn } from '../../../utils/cn';

// WHY: next/image пропускает только хосты из images.remotePatterns в next.config.mjs — список должен совпадать
const OPTIMIZED_PREFIXES = [
  'https://community.akamai.steamstatic.com/economy/image/',
  'https://cf92270d-b971-4f1a-9fc8-1cde9031d973.selstorage.ru/wiki/',
];

export const isOptimizedImage = (src: string): boolean => OPTIMIZED_PREFIXES.some((prefix) => src.startsWith(prefix));

interface WikiRemoteImageProps {
  src: string;
  alt: string;
  sizes: string;
  className?: string;
  preload?: boolean;
  eager?: boolean;
}

// WHY: eager — картинки первого экрана грузятся сразу, без lazy; preload вдобавок кладёт их в <head> с высоким приоритетом
export const WikiRemoteImage: FC<WikiRemoteImageProps> = ({ src, alt, sizes, className, preload = false, eager = false }) =>
  isOptimizedImage(src) ? (
    <Image
      src={src}
      alt={alt}
      fill
      sizes={sizes}
      preload={preload}
      loading={preload || eager ? 'eager' : 'lazy'}
      className={cn('object-contain', className)}
    />
  ) : (
    <img
      src={src}
      alt={alt}
      loading={preload || eager ? 'eager' : 'lazy'}
      decoding="async"
      className={cn('absolute inset-0 size-full object-contain', className)}
    />
  );
